export const NARVARO_HEADERS = [
    "Deltagare",
    "Totalt",
    "Totalt (h)",
    "Deltagit",
    "Deltagit (h)",
    "Frånvarande",
    "Frånvarande (h)",
    "Skadad",
    "Skadad (h)",
    "Frånvarande (%)",
    "Skadad (%)",
    "Status",
    "",
];

export function returnValueIfNotUndefined(value) {
    return value !== undefined && value !== null && value !== "allalag" ? value : "";
}
